export const storageMap = [
	{ key: '24 Hour Storage', label: '24 Hour Self Storage' },
	{
		key: 'Climate Controlled Storage',
		label: 'Climate Controlled Self Storage',
	},
	{ key: 'Drive-Up Access Storage', label: 'Drive Up Self Storage' },
	{
		key: 'Storage With Electricity',
		label: 'Self Storage with Electricity',
	},
	{ key: 'Wine Storage', label: 'Wine Self Storage' },
	{
		key: 'Free Truck Rental Storage',
		label: 'Free Truck Rental Self Storage',
	},

	{ key: 'Mini Storage', label: 'Mini Self Storage Units' },
	{ key: 'Small Self Storage Units', label: 'Small Self Storage Units' },
	{ key: 'Medium Self Storage Units', label: 'Medium Self Storage Units' },
	{ key: 'Large Self Storage Units', label: 'Large Self Storage Units' },
	{ key: 'Storage Lockers', label: 'Self Storage Lockers' },

	{ key: 'Boat Storage', label: 'Self Storage for Boats' },
	{ key: 'Car Storage', label: 'Self Storage for Cars' },
	{ key: 'RV Storage', label: 'Self Storage for RVs' },
	{ key: 'Motorcycle Storage', label: 'Self Storage for Motorcycles' },
];
